import * as React from 'react'
import PropTypes from 'prop-types'
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import { cn } from '@tiptap-ui/lib/tiptap-utils'
import '@tiptap-ui/components/tiptap-ui-primitive/dropdown-menu/dropdown-menu.scss'

function DropdownMenu ({
  ...props
}) {
  return <DropdownMenuPrimitive.Root modal={false} {...props} />
}

DropdownMenu.propTypes = {
  // accepts Radix props
}

function DropdownMenuPortal ({
  ...props
}) {
  return <DropdownMenuPrimitive.Portal {...props} />
}

const DropdownMenuTrigger = React.forwardRef(
  ({ ...props }, ref) => <DropdownMenuPrimitive.Trigger ref={ref} {...props} />
)
DropdownMenuTrigger.displayName = DropdownMenuPrimitive.Trigger.displayName

const DropdownMenuGroup = DropdownMenuPrimitive.Group

const DropdownMenuSub = DropdownMenuPrimitive.Sub

const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup

const DropdownMenuItem = DropdownMenuPrimitive.Item

const DropdownMenuSubTrigger = DropdownMenuPrimitive.SubTrigger

const DropdownMenuSubContent = React.forwardRef(({ className, portal = true, ...props }, ref) => {
  const content = (
    <DropdownMenuPrimitive.SubContent ref={ref} className={cn('tiptap-dropdown-menu', className)} {...props} />
  )

  return portal
    ? (
      <DropdownMenuPortal {...(typeof portal === 'object' ? portal : {})}>
        {content}
      </DropdownMenuPortal>
      )
    : (
        content
      )
})
DropdownMenuSubContent.displayName =
  DropdownMenuPrimitive.SubContent.displayName
DropdownMenuSubContent.propTypes = {
  className: PropTypes.string,
  portal: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

const DropdownMenuContent = React.forwardRef(({ className, sideOffset = 4, portal = false, ...props }, ref) => {
  const content = (
    <DropdownMenuPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      onCloseAutoFocus={(e) => e.preventDefault()}
      className={cn('tiptap-dropdown-menu', className)}
      {...props}
    />
  )

  return portal
    ? (
      <DropdownMenuPortal {...(typeof portal === 'object' ? portal : {})}>
        {content}
      </DropdownMenuPortal>
      )
    : (
        content
      )
})
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName
DropdownMenuContent.propTypes = {
  className: PropTypes.string,
  sideOffset: PropTypes.number,
  portal: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuSub,
  DropdownMenuPortal,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
}
